import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type {
    CreateCustomerRequest,
    CreateCustomerResponse,
    DeleteCustomerRequest,
    DeleteCustomerResponse,
    ListCustomersRequest,
    ListCustomersResponse,
    UpdateCustomerRequest,
    UpdateCustomerResponse
} from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminCustomerApi = createApi({
    reducerPath: "adminCustomerApi",
    baseQuery: baseQueryAdminWithAuth,
    tagTypes: ["Customers"],
    endpoints: builder => ({
        listCustomers: builder.query<ListCustomersResponse, ListCustomersRequest>({
            query: body => ({
                url: `customer/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            }),
            providesTags: ["Customers"]
        }),
        createCustomer: builder.mutation<CreateCustomerResponse, CreateCustomerRequest>({
            query: body => ({
                url: "customer/create",
                method: "POST",
                body
            }),
            invalidatesTags: ["Customers"]
        }),
        updateCustomer: builder.mutation<UpdateCustomerResponse, UpdateCustomerRequest>({
            query: body => ({
                url: "customer/update",
                method: "POST",
                body
            }),
            invalidatesTags: ["Customers"]
        }),
        deleteCustomer: builder.mutation<DeleteCustomerResponse, DeleteCustomerRequest>({
            query: body => ({
                url: "customer/delete",
                method: "POST",
                body
            }),
            invalidatesTags: ["Customers"]
        })
    })
});

export const {
    useCreateCustomerMutation,
    useUpdateCustomerMutation,
    useDeleteCustomerMutation,
    useLazyListCustomersQuery,
    useListCustomersQuery
} = adminCustomerApi;
